import React, { memo, useState } from 'react';

import { Icons, SpinnerOverlay } from '@components/common';
import Dropzone from '@components/common/Dropzone';
import NavigateButtons from '@components/common/NavigateButtons';

import { IErrorsType, TFileTypes } from '@interfaces/import/import';

import { HUNDRED_PERCENT_LOADING } from '@constants/common';

import styles from './AttachDocuments.module.scss';

interface IAttachDocumentsProps {
	toggleUploadFilesModal: () => void;
	createUploadUrlAttachment: ({ files }: { files: Array<File> }) => void;
	onDropAcceptedHandler: () => void;
	fileRejectionErrorHandler: () => void;
	onUploadClickHandler: () => void;
	acceptedFileTypes: TFileTypes;
	fileErrors: IErrorsType;
	supportsText: string;
	maxBytes: number;
	progress?: number;
	uploadedFilesLength: number;
	isMultipleFiles?: boolean;
	additionalText?: string;
	uploadedText?: string;
	nextButtonText?: string;
	maxFiles?: number;
	isUploading?: boolean;
	filteredFiles?: Array<File>;
}

const AttachDocuments = ({
	toggleUploadFilesModal,
	fileRejectionErrorHandler,
	onDropAcceptedHandler,
	createUploadUrlAttachment,
	onUploadClickHandler,
	acceptedFileTypes,
	uploadedFilesLength,
	maxBytes,
	fileErrors,
	supportsText,
	progress,
	isMultipleFiles = true,
	additionalText,
	uploadedText,
	nextButtonText = 'Upload',
	maxFiles,
	isUploading,
	filteredFiles,
}: IAttachDocumentsProps) => {
	const [selectedFiles, setSelectedFiles] = useState<Array<File>>([]);
	const isDisabledUpload = !uploadedFilesLength || !(
		selectedFiles.length === uploadedFilesLength ||
		!!filteredFiles?.length
	);

	const isLoading = progress !== undefined ? progress !== HUNDRED_PERCENT_LOADING : false;

	return (
		<div className={styles.attachDocumentsContainer}>
			{(isLoading || isUploading) && <SpinnerOverlay />}
			<Dropzone
				acceptedFileTypes={acceptedFileTypes}
				createUploadUrl={createUploadUrlAttachment}
				errors={fileErrors}
				fileRejectionErrorHandler={fileRejectionErrorHandler}
				filteredFiles={filteredFiles}
				isMultipleFiles={isMultipleFiles}
				maxFiles={maxFiles}
				maxSize={maxBytes}
				onDropAcceptedHandler={onDropAcceptedHandler}
				setSelectedFiles={setSelectedFiles}
				supportsText={supportsText}
				uploadIcon={Icons.uploadFile}
				uploadedIcon={Icons.uploadedFile}
				uploadedText={uploadedText}
			/>
			{additionalText && <div className={styles.additionalText}>{additionalText}</div>}
			<div className={styles.buttons}>
				<NavigateButtons
					disabledNext={isDisabledUpload}
					nextText={nextButtonText}
					onCloseHandler={toggleUploadFilesModal}
					onNextHandler={onUploadClickHandler}
				/>
			</div>
		</div>
	);
};

export default memo(AttachDocuments);
